import {
  CentralFrame,
  newCentralFrame,
  LocalInfo,
  newLocalInfo,
  LocalFrame,
  newLocalFrame,
} from '../../model/CollectiveAgreement';
import { CentralFrameTable } from './CentralFrame';
import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  useMediaQuery,
  useTheme,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  AlertColor
} from '@mui/material';
import {LocalInfoFormRef} from './LocalInfoForm'
import { useApi } from '../../services/HttpService';
import { GridApiCommunity } from '@mui/x-data-grid/internals';
import { LocalInfoForm } from './LocalInfoForm';
import { LocalFrameTable } from './LocalFrame';

export const CollectiveAgreementCalculator = () => {
  type Stage = "select" | "central" | "form" | "result";
  const [stage, setStage] = useState<Stage>("select");
  const theme = useTheme();
  const { api, response, error, isLoading } = useApi();
  const { api: GetLocalFrame, response: getLocalFrameResponse, error: getLocalFrameError, isLoading: getLocalFrameIsLoading } = useApi();
  const apiRef = useRef<GridApiCommunity>(null);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [centralFrames, setCentralFrames] = useState<CentralFrame[]>([]);
  const [selectedCentralFrame, setSelectedCentralFrame] = useState<CentralFrame | null>(null);
  // const [localInfo, setLocalInfo] = useState<LocalInfo | null>(null);
  const [localFrame, setLocalFrame] = useState<LocalFrame | null>(null);
  const LocalInfoFormRef = useRef<LocalInfoFormRef>(null);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState<AlertColor | undefined>('error');


  useEffect(() => {
    api("/GetCollectiveAgreementCalculatorData", "GET").then((res) => {
      if (res?.statusCode === 200) {
        setCentralFrames(res.central_info_data || []);
      }
    });
  }, []);

  const setDisplayMessage = (message: string, type: AlertColor = 'error') => {
      setMessage(message);
      setMessageType(type);
    }

  const calculateLocalFrame = (li: LocalInfo, cf: CentralFrame) => {
    GetLocalFrame("/GetLocalFrame", "POST", { ...li, cf }).then(res => {
      if (res && res.statusCode === 200) {
        setLocalFrame(res.data || null);
        setStage("result");
      }else{
        if (res.error) {
          alert("Test det er skjedd en feil")
          setDisplayMessage("Det er skjedd en feil");
        }
      }
    });
  }

  // const handleSelectChange = (event: any) => {
  //   const selectedId = event.target.value;
  //   const selected = centralFrames.find((c) => c.id === selectedId);
  //   if (selected) {
  //     setSelectedCentralFrame(selected);
  //   }
  // };

  return (
    <Box sx={{ m: 1, mt: 3, p: { xs: 1, md: 3 }, pt: 0, width: '100%' }}>
      <Typography variant="h5" gutterBottom>
        Tariff kalkulator
      </Typography>
  
      {/* 0 results */}
      {centralFrames.length === 0 && stage === "select" && (
        <Typography variant="body1" align="center">
          No valid data
        </Typography>
      )}
  
      {/* Selection stage */}
      {stage === "select" && centralFrames.length === 1 && (
        <Box textAlign="center">
          <Typography variant="body1" gutterBottom>
            Description about the data here.
          </Typography>
          <Button variant="contained" onClick={() => {
            setSelectedCentralFrame(centralFrames[0]);
            setStage("central");
          }}>
            Proceed
          </Button>
        </Box>
      )}
  
      {stage === "select" && centralFrames.length > 1 && (
        <Box textAlign="center">
          <Typography variant="body1" gutterBottom>
            Please select a central frame from the list.
          </Typography>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel id="centralframe-select-label">Select</InputLabel>
            <Select
              labelId="centralframe-select-label"
              value={selectedCentralFrame?.id || ""}
              onChange={(e) => {
                const selected = centralFrames.find(f => f.id === e.target.value);
                if (selected) {
                  setSelectedCentralFrame(selected);
                  setStage("central");
                }
              }}
              label="Select"
            >
              {centralFrames.map((frame) => (
                <MenuItem key={frame.id} value={frame.id}>
                  {frame.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}
  
      {/* Central info stage */}
      {stage === "central" && selectedCentralFrame && (
        <Box>
          <CentralFrameTable item={selectedCentralFrame} />
          <Box mt={2}>
            <Button variant="contained" onClick={() => setStage("form")}>
              Proceed
            </Button>
            <Button variant="outlined" onClick={() => setStage("select")} sx={{ ml: 2 }}>
              Go back
            </Button>
          </Box>
        </Box>
      )}
  
      {/* Form stage */}
      {stage === "form" && selectedCentralFrame && (
        <Box>
          <LocalInfoForm CentralFrame={selectedCentralFrame} ref={LocalInfoFormRef} />
          <Box mt={2}>
            <Button
              variant="contained"
              onClick={() => {
                const infoRef = LocalInfoFormRef.current?.getItem();
                if (infoRef && LocalInfoFormRef.current?.valid()) {
                  calculateLocalFrame(infoRef, selectedCentralFrame);
                }
              }}
            >
              Submit
            </Button>
            <Button variant="outlined" onClick={() => setStage("central")} sx={{ ml: 2 }}>
              Go back
            </Button>
          </Box>
        </Box>
      )}
  
      {/* Result stage */}
      {stage === "result" && localFrame && (
        <Box>
          <LocalFrameTable item={localFrame} CentralFrame={selectedCentralFrame} />
          <Box mt={2}>
            <Button variant="contained" onClick={() => {
              // Reset everything
              setStage("select");
              setSelectedCentralFrame(null);
              setLocalFrame(null);
            }}>
              Reset
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};
